"use strict";

var _regeneratorRuntime = require("/go/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@material-ui/core");

var _classnames = _interopRequireDefault(require("classnames"));

var _ljhAnalytics = _interopRequireDefault(require("@clients-modules/js/ljhAnalytics"));

var _react = _interopRequireWildcard(require("react"));

var _RealHubWarningDialog = _interopRequireDefault(require("./RealHubWarningDialog"));

var _styles = _interopRequireDefault(require("./styles"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DashboardLinksSection = /*#__PURE__*/function (_Component) {
  _inherits(DashboardLinksSection, _Component);

  var _super = _createSuper(DashboardLinksSection);

  function DashboardLinksSection() {
    var _this;

    _classCallCheck(this, DashboardLinksSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      showRealHubWarningDialog: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleItemClick", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(linkUrl, title, linkVariant) {
        var link;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (linkVariant === "system.realhub-login" && !linkUrl) {
                  _this.setState({
                    showRealHubWarningDialog: true
                  });
                }

                link = linkUrl;

                if (link) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                _this.routeToLink(linkUrl, title);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "routeToLink", function (linkUrl, title, linkVariant) {
      _ljhAnalytics["default"].track("Dashboard link click", {
        linkUrl: linkUrl,
        title: title
      });

      if (linkVariant === "link.external") {
        window.open(linkUrl, "_blank");
      }

      window.open(linkUrl);
    });

    return _this;
  }

  _createClass(DashboardLinksSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var showRealHubWarningDialog = this.state.showRealHubWarningDialog;
      var _this$props = this.props,
          classes = _this$props.classes,
          offices = _this$props.offices,
          serviceSections = _this$props.serviceSections;

      if (!serviceSections) {
        return null;
      }

      return serviceSections.map(function (section) {
        return /*#__PURE__*/_react["default"].createElement(_core.Grow, {
          key: section.title,
          "in": true
        }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
          item: true,
          xs: 12,
          md: 4
        }, /*#__PURE__*/_react["default"].createElement(_RealHubWarningDialog["default"], {
          show: showRealHubWarningDialog,
          offices: offices,
          onClose: function onClose() {
            return _this2.setState({
              showRealHubWarningDialog: false
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_core.Paper, {
          className: classes.sectionContainer
        }, /*#__PURE__*/_react["default"].createElement(_core.Table, {
          className: classes.table
        }, /*#__PURE__*/_react["default"].createElement(_core.TableHead, null, /*#__PURE__*/_react["default"].createElement(_core.TableRow, null, /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
          className: classes.tableHeadCell
        }, section.title))), /*#__PURE__*/_react["default"].createElement(_core.TableBody, null, section.items.map(function (_ref2) {
          var linkUrl = _ref2.linkUrl,
              title = _ref2.title,
              linkVariant = _ref2.linkVariant,
              iconUrl = _ref2.iconUrl;
          return /*#__PURE__*/_react["default"].createElement(_core.TableRow, {
            className: (0, _classnames["default"])(classes.tableRow, classes.tableRowHover),
            key: title,
            onClick: function onClick() {
              return _this2.handleItemClick(linkUrl, title, linkVariant);
            }
          }, /*#__PURE__*/_react["default"].createElement(_core.TableCell, {
            className: classes.tableCell
          }, /*#__PURE__*/_react["default"].createElement("img", {
            className: classes.serviceIcon,
            src: iconUrl,
            width: "24",
            height: "24",
            alt: ""
          }), title));
        }))))));
      });
    }
  }]);

  return DashboardLinksSection;
}(_react.Component);

DashboardLinksSection.propTypes = {
  classes: _propTypes["default"].object
};

var _default = (0, _withStyles["default"])(_styles["default"])(DashboardLinksSection);

exports["default"] = _default;